import { useAppHeaderObserver } from 'hooks/useAppLayoutObservers'
import { memo, useRef } from 'react'
import NavBarGlobalBar from './NavBarGlobalBar'
import NavBarTertiaryBar from './NavBarTertiaryBar'
import NavBarUtilBar from './NavBarUtilBar'
import styled from 'styled-components'
import { useWeddingGiftRegistryContext } from 'weddings/contexts/WeddingGiftRegistryContext'
import WeddingNavBarGiftRegistryBar from 'weddings/components/WeddingNavBarGiftRegistryBar'
import clsx from 'clsx'
import zIndex from 'styles/tools/z-index'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const NavBarContainer = styled.div`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  @media print {
    display: none;
  }

  &.wedding-gift-registry-navbar {
    position: sticky;
    top: 0;
    z-index: ${zIndex.floatingPanel};
    background: ${props => props.theme.palette.neutral.surface.normalBackground};
  }
`

function NavBar() {
  const ref = useRef<HTMLDivElement>(null)
  const { isActive: isWeddingGiftRegistry } = useWeddingGiftRegistryContext()

  useAppHeaderObserver(ref, isWeddingGiftRegistry ? 'sticky' : 'static')

  return <NavBarContainer ref={ref} data-testid="navbar" className={clsx({ 'wedding-gift-registry-navbar': isWeddingGiftRegistry })}>
    <CSSBreakpoint min="tablet"><NavBarTertiaryBar /></CSSBreakpoint>
    {!isWeddingGiftRegistry && <NavBarUtilBar />}
    {isWeddingGiftRegistry && <WeddingNavBarGiftRegistryBar />}
    <NavBarGlobalBar />
  </NavBarContainer>
}

export default memo(NavBar)
